import { action, observable } from 'mobx'
import { validationContext, required } from 'validx'
import { ModalViewModel } from '@/infra/ModalViewModel'
import { PropertyType } from '@taxfyle/txf-api-client'
import { AddressFieldSetViewModel } from '../../../components/AddressFieldSet'
import type { ContactAddress } from '../../../models'
import { validateObject } from '@/utils/validx-util'

export interface AddRentalDialogViewModelOptions {
  onSaved: (rental: NewRentalData) => void
}

export interface NewRentalData {
  propertyType: PropertyType
  address: ContactAddress
}

export class AddRentalDialogViewModel {
  readonly modal = new ModalViewModel()
  @observable accessor propertyType: PropertyType = PropertyType.SingleFamily

  readonly address = new AddressFieldSetViewModel(true)

  readonly validation = validationContext(this, {
    propertyType: [required('Property type is required')],
    address: [validateObject()],
  })

  constructor(private readonly _options: AddRentalDialogViewModelOptions) {}

  @action.bound
  reset() {
    this.propertyType = PropertyType.SingleFamily
    this.address.reset()
    this.validation.reset()
  }

  @action.bound
  showDialog() {
    this.reset()
    this.modal.show()
  }

  @action.bound
  closeDialog() {
    this.modal.close()
  }

  @action.bound
  save() {
    this.validation.reset().validate()
    if (!this.validation.isValid) {
      return
    }

    const rentalData: NewRentalData = {
      propertyType: this.propertyType,
      address: this.address.toProps(),
    }

    this._options.onSaved(rentalData)
    this.closeDialog()
  }
}
